import { extendMediaItemByLabelPrice } from '@/tools'
import type { VodBundleInfo } from '@setplex/tria-api'
import { type TFunction } from 'i18next'
import type { AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import type { UiVodBundleInfo } from '~/shared/interfaces/vod'

export const formatVodBundleInfoToUi =
  (t: TFunction, adjust: AdjustPurchaseableFn) =>
  (bundle: VodBundleInfo): UiVodBundleInfo => {
    bundle = adjust(bundle)
    const { labelPrice, rented } = extendMediaItemByLabelPrice(bundle)
    return {
      ...bundle,
      quantityText: t('movie_count', {
        count: bundle.contentQuantity,
      }),
      labelPrice,
      rented,
      link: `/content/movie/bundles/${bundle.id}`,
    }
  }
